


































































































































































































































































































import { editFactory } from '@/main/pages';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { showAlert } from '@/main/utils/notifications';
import { dropdownListProvider } from '@/main/dropdownApi';
import _ from 'lodash';

import { getMonths, get24Hours, getDays, isArrayDescending } from '@/main/utils/numbers';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		DodavatelSelect: Dodavatel.components.Select,
	},
	data() {
		return {
			criteriaMonth: getMonths(),
			criteriaHour: get24Hours(),
			criteriaDay: getDays(),
			tabs: {
				ETD: { id: 'ETD', labelKey: 'ETD_HIGHLIGHTING_CRITERIA' },
				partsExpiry: { id: 'partsExpiry', labelKey: 'PARTS_EXPIRY_CRITERIA' },
				partsReservation: { id: 'partsReservation', labelKey: 'PARTS_RESERVATION_CRITERIA' },
				serviceDueRemindersCriteria: { id: 'serviceDueRemindersCriteria', labelKey: 'CRITERIA_SERVICE_DUE_REMINDERS' },
				watchlistedConfiguration: { id: 'watchlistedConfiguration', labelKey: 'WATCHLISTED_CONFIGURATION' },
			},
		};
	},
	computed: {
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${editMutations.VYROBEK_VOZ_DODAVATEL_SELECT_MAPPER}`,
			};
		},
		criteriaDays(): number[] {
			return [this.CriteriaServiceDueDayFirst,
				this.CriteriaServiceDueDaySecond,
				this.CriteriaServiceDueDayThird,
				this.CriteriaServiceDueDayFourth];
		},
		isCriteriaDaysValid(): boolean {
			return !(this.criteriaDays.some(_.isNil) || this.criteriaDays.some((e => e! <= 0)));
		},
		etdCriteriaColors(): number[] {
			return [this.EtdCriteriaColorOne,
				this.EtdCriteriaColorTwo,
				this.EtdCriteriaColorThree];
		},
		isETDCriteriaValid(): boolean {
			return (this.etdCriteriaColors.some(_.isNil) || this.etdCriteriaColors !== null);
		},
		partsExpiryCriteriaColors(): number[] {
			return [this.CriteriaColorOne,
				this.CriteriaColorTwo,
				this.CriteriaColorThree];
		},
		isPartsExpiryCriteriaValid(): boolean {
			return (this.partsExpiryCriteriaColors.some(_.isNil) || this.partsExpiryCriteriaColors !== null);
		},
		partsReserveCriteriaColors(): number[] {
			return [this.ReseverPartsColorOne,
				this.ReseverPartsColorTwo,
				this.ReseverPartsColorThree];
		},
		isPartsReserveCriteriaValid(): boolean {
		 return (this.partsReserveCriteriaColors.some(_.isNil) || this.partsReserveCriteriaColors !== null);
		},
	},
	methods: {
		async saveClick() {
			if (this.EnableServiceDueCriteria) {
				if(this.isCriteriaDaysValid){
				if (isArrayDescending(this.criteriaDays) === false) {
					showAlert({
						message: this.LocalizeChyboveHlasky('serviceDueRemInValid'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky('serviceDueRemInValid'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			}
			if (this.PrimaryEmailAddress !== null && this.PrimaryEmailAddress === this.SecondaryEmailAddress) {
				showAlert({
					message: this.LocalizeChyboveHlasky('SameMailMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			if (!this.isETDCriteriaValid) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ETDCriteriaInvalid'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			if (!this.isPartsExpiryCriteriaValid) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartsExCriteriaInvalid'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			if (!this.isPartsReserveCriteriaValid) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartsResCriteriaInvalid'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			this.save(true);
			return true;
		},
		async onBlurToCheckGreterValue() {
			if (this.ReseverPartsColorTwo !== null) {
				if (this.ReseverPartbetweenTwoto !== null && this.ReseverPartbetweenTwo! < this.ReseverPartbetweenTwoto) {
					this.ReseverPartGreaterthan = this.ReseverPartbetweenTwoto + 1;
				} else {
					this.ReseverPartsColorTwo = 0;
					this.ReseverPartsColorThree = 0;
				}
			}
		},
		async onBlurToCheckLessThanValue() {
			if (this.ReseverPartZeroto !== null && this.ReseverPartZeroto !== 0) {
				this.ReseverPartbetweenTwo = this.ReseverPartZeroto + 1;
			} else {
				this.ReseverPartsColorOne = 0;
			}
		},
		async updateServiceDueDetails() {
			if (!this.EnableServiceDueCriteria) {
				this.CriteriaServiceDueDayFirst = 0;
				this.CriteriaServiceDueDaySecond = 0;
				this.CriteriaServiceDueDayThird = 0;
				this.CriteriaServiceDueDayFourth = 0;
			}
		},
		async onPrimaryUserChange(userRole: string | undefined) {
			this.dropdownList.Pracovnik = [];
			if (userRole) {
				const { data: userListForRole } = await dropdownListProvider.GetUsers(userRole);
				if (userListForRole) {
					this.dropdownList.Pracovnik = userListForRole;
				}
			}
		},
	},
});
